import React, { useState, useEffect } from "react";
import Ellipse from "../../images/Ellipse.png";
import tooltip from "../../images/tooltip.png";
import visa from "../../images/visa-img.png";
import cardimg from "../../images/chip.png";
import righticon from "../../images/right-ic.png";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  card_details,
  customer_subscription,
  cancel_subscription,
  renew_subscription,
  user_token,
} from "../../redux/authslice";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Modal from "react-bootstrap/Modal";
import Card from "./Card";

function ManagePlanFree() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cardDetails, customersubscrip } = useSelector(
    (state) => state.counter
  );
  const userToken = useSelector((state) => state.counter.userToken);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [object, setObject] = useState({
    subid: "",
    pay: false,
  });

  useEffect(() => {
    dispatch(card_details({ dispatch }));
    dispatch(customer_subscription(dispatch));
    dispatch(user_token(dispatch));
  }, []);

  useEffect(() => {
    if (customersubscrip?.length > 0) {
      const { subscription_id, auto_pay } = customersubscrip[0];
      setObject({
        subid: subscription_id,
        pay: auto_pay,
      });
    }
  }, [customersubscrip]);

  const handlerenew = () => {
    if (customersubscrip?.length > 0) {
      let id = customersubscrip[0].subscription_id;
      setObject((prevData) => ({
        ...prevData,
        pay: !prevData.pay,
        subid: id,
      }));
      dispatch(renew_subscription({ subid: id, pay: !object.pay, dispatch }));
    }
  };

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <img src={righticon} alt="Next" />,
    prevArrow: <img src={righticon} alt="Previous" />,
  };
  const disableSlider = cardDetails && cardDetails?.length <= 2;

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  };

  const getIntervalText = (interval, intervalCount) => {
    if (interval === "month") {
      if (intervalCount === 1) return "Monthly";
      if (intervalCount === 3) return "Quarterly";
    } else if (interval === "year" && intervalCount === 1) {
      return "Yearly";
    }
    return `${intervalCount} ${interval}`;
  };

  return (
    <>
      <div>
        <section className="manage-plan">
          <div className="container">
            <button className="div-save-bt" onClick={() => navigate(-1)}>
              <IoMdArrowBack />
              &nbsp;Back
            </button>
            <div className="row">
              <div className="col-lg-12">
                <div className="plan-bill">
                  <div className="plan-bill-1">
                    <p className="plan-p-1">Plan &amp; billing</p>
                    <p className="plan-p-2">Manage your plan and payments</p>
                  </div>
                  <div className="plan-bill-2">
                    <button
                      className="plan-p-bt"
                      onClick={() => navigate("/plan-details")}
                    >
                      {customersubscrip?.length > 0
                        ? "Cancel subscription / card"
                        : "No subscription"}
                    </button>
                  </div>
                </div>
                <div className="current-plan">
                  <p className="plan-p-1">Current plan</p>
                  <button
                    className="plan-p-bt"
                    onClick={() => navigate("/paymentsubscription")}
                  >
                    {customersubscrip?.length > 0 ? "Change plan" : "Buy plan"}
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              {customersubscrip?.length > 0 ? (
                customersubscrip?.map((value, index) => {
                  return (
                    <div key={index} className="col-lg-6">
                      <div className="plan-left-part">
                        <div className="plan-left-part-1">
                          <p className="plan-left-part-p1">
                            {getIntervalText(
                              value?.interval,
                              value?.interval_count
                            )}{" "}
                            plan
                          </p>
                          <p className="plan-left-part-p2">
                            £ {value?.price} /{" "}
                            {getIntervalText(
                              value?.interval,
                              value?.interval_count
                            )}
                          </p>
                          <p className="plan-left-part-p2">
                            {/* {value.metadata?.level} */}
                          </p>
                        </div>
                        <div className="plan-left-part-2">
                          <button className="active-bt">
                            <span />
                            Active
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-lg-6">
                  <div className="plan-left-part">
                    <div className="plan-left-part-1">
                      <p className="plan-left-part-p1">{""}</p>
                      <p className="plan-left-part-p2">{""} No active plan</p>
                      <p className="plan-left-part-p2">{""}</p>
                    </div>
                    <div className="plan-left-part-2"></div>
                  </div>
                </div>
              )}

              <div className="col-lg-6">
                <div className="plan-left-part">
                  <div className="plan-left-part-1">
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        Auto-renew
                      </label>
                      <p className="plan-left-part-p2">
                        {customersubscrip[0] &&
                        customersubscrip[0]?.next_payment
                          ? formatDate(customersubscrip[0]?.next_payment)
                          : ""}
                      </p>
                    </div>
                  </div>
                  <div className="plan-left-part-2">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        disabled={customersubscrip[0]?.price == "0.00"}
                        onClick={handlerenew}
                        checked={object.pay}
                      />
                      {/* <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        Default switch checkbox input
                      </label> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <div className="common-usage">
                  <p className="common-Usage-1">Usage</p>
                  <p className="common-usage-2">
                    Your usage is renewed every month
                  </p>
                </div>
                <div className="lft-card-12">
                  <img className="elips-css" src={Ellipse} alt="Ellipse" />
                  <p className="tooltip-p">
                    Quiz generated <img src={tooltip} alt="Tooltip" />
                  </p>
                  <p className="tooltip-p1">
                    {userToken.used_token} of {userToken.total_token}
                  </p>
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-label="Basic example"
                      aria-valuenow={userToken.used_token}
                      aria-valuemin={0}
                      aria-valuemax={userToken.total_token}
                      style={{
                        width: `${
                          (userToken.used_token / userToken.total_token) * 100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="common-usage">
                      <p className="common-Usage-1">Payment methods</p>
                      <p className="common-usage-2">
                        Manage your payment methods
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="common-Usage AddMethodRight">
                      <button className="Add-method" onClick={handleShow}>
                        Add method
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="card-ul-12">
                      {cardDetails && cardDetails?.length > 0 ? (
                        disableSlider ? (
                          <div className="row justify-content-center">
                            {cardDetails?.map((card, index) => (
                              <div key={index} className="col-lg-6">
                                <div className="rup-background">
                                  <div className="rup-card">
                                    <div className="rup-text">
                                      <img
                                        className="viva-img1"
                                        src={visa}
                                        alt="Visa"
                                      />
                                      <img
                                        className="rup-img-2"
                                        src={visa}
                                        alt="Visa"
                                      />
                                    </div>
                                    <div className="rup-no">
                                      <input
                                        type="text"
                                        className="card-number"
                                        placeholder={`* * **** ${card.card_number}`}
                                        readOnly
                                      />
                                      <img
                                        className="viva-img"
                                        src={cardimg}
                                        alt="Chip"
                                      />
                                    </div>
                                    <div className="card-holder-info">
                                      <div className="card-left">
                                        <p className="card-holder-name">
                                          Name on Card
                                        </p>
                                        <p className="card-holder-name1">
                                          {card.name_on_card}
                                        </p>
                                      </div>
                                      <div className="card-right">
                                        <p className="card-holder-name">
                                          Expiry Date
                                        </p>
                                        <p className="card-holder-name1">
                                          {`${card.exp_month}/${card.exp_year}`}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <Slider {...settings}>
                            {cardDetails?.map((card, index) => (
                              <div key={index} className="rup-background">
                                <div className="rup-card">
                                  <div className="rup-text">
                                    <img
                                      className="viva-img1"
                                      src={visa}
                                      alt="Visa"
                                    />
                                    <img
                                      className="rup-img-2"
                                      src={visa}
                                      alt="Visa"
                                    />
                                  </div>
                                  <div className="rup-no">
                                    <input
                                      type="text"
                                      className="card-number"
                                      placeholder={`* * **** ${card.card_number}`}
                                      readOnly
                                    />
                                    <img
                                      className="viva-img"
                                      src={cardimg}
                                      alt="Chip"
                                    />
                                  </div>
                                  <div className="card-holder-info">
                                    <div className="card-left">
                                      <p className="card-holder-name">
                                        Name on card
                                      </p>
                                      <p className="card-holder-name1">
                                        {card.name_on_card}
                                      </p>
                                    </div>
                                    <div className="card-right">
                                      <p className="card-holder-name">
                                        Expiry Date
                                      </p>
                                      <p className="card-holder-name1">
                                        {`${card.exp_month}/${card.exp_year}`}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        )
                      ) : (
                        <p className="textbold">
                          <b>No Data Found.</b>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add new card</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
        >
          <Card setShow={setShow} />
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none" }} />
      </Modal>
    </>
  );
}

export default ManagePlanFree;
